<cdk-table [id]="tableId" [dataSource]="rows" [ngClass]="{'empty-table': rows.length === 0}">
  <ng-container *ngFor="let column of columns" [cdkColumnDef]="column.name">

    <cdk-header-cell *cdkHeaderCellDef (click)="onClickColumn(column)" [ngClass]="{'add-ttc': column.name === 'Montant' || column.name === 'Solde',
                  'is-sorted': column.sort === 'asc' || column.sort === 'desc',
                  'not-sortable': column.sort === false,
                  'status-col': column.name === 'DocumentStatus',
                  'small-cell': column.name === 'Panier' || column.name === 'UrlPdf',
                  'big-cell': column.name === 'DocumentNumber' || column.name === 'DocumentStatus'}">
      {{column.title}}
      <input *ngIf="column.name === 'Panier'" type="checkbox" [(ngModel)]="isAllRowsSelected"
        [apply-write-rights]="column.requireReadRight">
      <sup *ngIf="column.name === 'Montant' || column.name === 'Solde'" class="ttc">TTC &nbsp;</sup>
      <fa-icon *ngIf="column.sort === ''" [icon]="faSort"></fa-icon>
      <fa-icon *ngIf="column.sort === 'asc'" [icon]="faSortUp"></fa-icon>
      <fa-icon *ngIf="column.sort === 'desc'" [icon]="faSortDown"></fa-icon>
    </cdk-header-cell>

    <cdk-cell *cdkCellDef="let row" (click)="onClickCell(row, column, $event)" [ngClass]="{'pdf-cell': column.name === 'UrlPdf',
                  'solde-col': column.name === 'Solde',
                  'small-cell': column.name === 'Panier' || column.name === 'UrlPdf',
                  'big-cell': column.name === 'DocumentNumber' || column.name === 'DocumentStatus'}"
      [apply-write-rights]="column.requireReadRight">
      <span *ngIf="column.responsiveTitle" class="responsive-col-title">{{column.responsiveTitle}} &nbsp;</span>

      <div [ngSwitch]="column.typeColumn">
        <div *ngSwitchCase="CdkTableTypeColumn.date" [ngClass]="{'expired-date': column.name === 'DateEcheance' && row.isDateEcheanceExpired
                                      && row.State === EtatEcriture.NON_REGLE}">
          {{row[column.name] | dateFormat}}
        </div>

        <div *ngSwitchCase="CdkTableTypeColumn.money">
          {{row[column.name] | currency: 'EUR' : 'symbol' :'1.2-2'}}
        </div>

        <div *ngSwitchCase="CdkTableTypeColumn.rowImage">
          <div *ngIf="column.name === 'Panier'">
            <input type="checkbox" name="panier" [checked]="row.IsInshoppingCart"
              [apply-write-rights]="column.requireReadRight">
          </div>
        </div>

        <div *ngSwitchCase="CdkTableTypeColumn.imageLink">
          <a class="url-pdf center-cell" data-testid="bill-asset-download"
            (click)="isUrlValid($event, row)"
            (auxclick)="isUrlValid($event, row)"
            (mousedown)="isUrlValid($event, row)"
            (keydown.enter)="isUrlValid($event, row)"
            (keydown.space)="isUrlValid($event, row)"
            (contextmenu)="$event.preventDefault(); $event.stopPropagation()"
            href="about:blank" role="link" tabindex="0" rel="noopener"></a>
        </div>

        <div *ngSwitchDefault [ngClass]="{'add-avoir': column.name === 'DocumentNumber' && row.TypePiece === TypePiece.AVOIR,
          'document-status': column.name === 'DocumentStatus',
          'a-regler': column.name === 'DocumentStatus' && row.DocumentStatus === 'A régler',
          'en-retard': column.name === 'DocumentStatus' && row.DocumentStatus === 'En retard',
          'reglee': column.name === 'DocumentStatus' && row.DocumentStatus === 'Réglée',
          'en-traitement': column.name === 'DocumentStatus' && (row.DocumentStatus === 'En traitement' ||
            row.DocumentStatus === 'Prélèvement en\u00A0cours' || row.DocumentStatus === 'Prélèvement à\u00A0venir'),
          'en-redressement': column.name === 'DocumentStatus' && row.DocumentStatus === 'En redressement',
          'etalement': column.name === 'DocumentStatus' && row.DocumentStatus === 'Etalement'}"
          [attr.data-testid]="column.name === 'DocumentNumber' ? getStatusDataTestid(row.DocumentStatus, row.TypePiece === TypePiece.AVOIR) : null">
          {{row[column.name]}}
        </div>
      </div>

    </cdk-cell>

  </ng-container>

  <cdk-header-row *cdkHeaderRowDef="displayedColumns"></cdk-header-row>

  <cdk-row *cdkRowDef="let row; columns: displayedColumns; first as isFirst; last as isLast"
    [ngClass]="{'first-row': isFirst, 'last-row': isLast, 'clickable': clickableRows}" data-testid="table-row">
  </cdk-row>

</cdk-table>

<fs-pagination id="pg-factures" [currentPage]="currentPage" (pageAsked)="onPageAsked($event)" [totalPages]="totalPages"
  [totalEntries]="totalEntries" [maxSize]="itemsPerPage" [listSizeItemsPerPage]="listSizeItemsPerPage"
  [callback]="onCallbackPage" (changeSizePage)="onChangeSizePage($event)"
  [ngClass]="{'empty-table': rows.length === 0}">
</fs-pagination>
